import { IsString, MaxLength, MinLength } from 'class-validator';

export class UpdateProfileNameDto {
  @IsString()
  @MinLength(1)
  @MaxLength(100)
  firstName!: string;

  @IsString()
  @MinLength(1)
  @MaxLength(100)
  lastName!: string;
}
